import { render, staticRenderFns } from "./ikdcList.vue?vue&type=template&id=647debbe&scoped=true&"
import script from "./ikdcList.vue?vue&type=script&lang=js&"
export * from "./ikdcList.vue?vue&type=script&lang=js&"
import style0 from "./ikdcList.vue?vue&type=style&index=0&id=647debbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647debbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('647debbe')) {
      api.createRecord('647debbe', component.options)
    } else {
      api.reload('647debbe', component.options)
    }
    module.hot.accept("./ikdcList.vue?vue&type=template&id=647debbe&scoped=true&", function () {
      api.rerender('647debbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/ikdcList.vue"
export default component.exports